// libs
import React, { memo } from 'react';

//components
import Checkbox from '@nykaa/ui-components/Checkbox';
import ColorImage from 'shared/components/Filter/components/ColorImage';

//styles
import { List, OptionName, OptionCount, ValueContainer } from './styles';

// defs
import { ALIGNMENT_TYPE, Value } from 'shared/components/Filter/types';

interface FilterCheckboxProps {
  value: Value;
  onFilterSelection: (filterId: string) => VoidFunction;
  isSelected: boolean;
  isHighlighted?: boolean;
  alignmentType?: ALIGNMENT_TYPE;
  className?: string;
}

function FilterCheckbox({
  value,
  onFilterSelection,
  isSelected,
  isHighlighted = true,
  alignmentType = ALIGNMENT_TYPE.RIGHT,
  className = '',
}: FilterCheckboxProps) {
  const EMPTY_FUNC = () => {};
  const { id, name, productCount } = value;

  const onClickHandler: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onFilterSelection(id);
  };

  return (
    <List
      isLeftAligned={alignmentType === ALIGNMENT_TYPE.LEFT}
      onClick={onClickHandler}
      isDisabled={!isHighlighted}
      isSelected={isSelected}
      className={className}
    >
      <Checkbox checked={isSelected} onClick={EMPTY_FUNC} onChange={EMPTY_FUNC} />
      <ValueContainer isLeftAligned={alignmentType === ALIGNMENT_TYPE.LEFT}>
        <ColorImage value={value}></ColorImage>
        <OptionName title={name} isSelected={isSelected}>
          {name}
        </OptionName>
        {Number(value?.productCount) > 0 && <OptionCount>{productCount}</OptionCount>}
      </ValueContainer>
    </List>
  );
}

export default memo(FilterCheckbox);
